import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

import { articles } from "../data/articles";
import { ArticleCard } from "./ArticleCard";
import { LocalizedLink } from "./LocalizedLink";
import { useLanguage } from "../i18n/LanguageProvider";

const PREVIEW_COUNT = 3;

export const Articles = () => {
  const { t } = useLanguage();
  const preview = articles.slice(0, PREVIEW_COUNT);

  return (
    <section
      id="articles"
      data-testid="articles-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-sm tracking-widest uppercase text-zinc-500 font-medium mb-4"
        >
          {t("articles.label")}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-3xl md:text-4xl font-semibold tracking-tight text-white/90 mb-16"
        >
          {t("articles.sectionTitle")}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {preview.map((article, i) => (
            <ArticleCard key={article.id} article={article} index={i} />
          ))}
        </div>

        {/* View All */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.2 }}
          className="mt-10 flex justify-center"
        >
          <LocalizedLink
            to="/articles"
            data-testid="view-all-articles-btn"
            className="inline-flex items-center gap-2 bg-zinc-900 text-white border border-zinc-800 hover:border-zinc-700 hover:bg-zinc-800 px-6 py-3 rounded-full font-medium text-sm transition-colors duration-200"
          >
            {t("articles.viewAll")}
            <ArrowRight size={16} strokeWidth={1.5} />
          </LocalizedLink>
        </motion.div>
      </div>
    </section>
  );
};
